import React from 'react';
import './ScreenerSearchControls.css';

interface ScreenerSearchControlsProps {
  globalFilter: string;
  onGlobalFilterChange: (value: string) => void;
  resultsCount: number;
  className?: string;
}

const ScreenerSearchControls: React.FC<ScreenerSearchControlsProps> = ({
  globalFilter,
  onGlobalFilterChange,
  resultsCount,
  className = ""
}) => {
  return (
    <section className={`screener-controls ${className}`}>
      <div className="section-container">
        <div className="controls-row">
          <div className="search-group">
            <input
              type="text"
              placeholder="Search by symbol or company..."
              value={globalFilter ?? ''}
              onChange={(e) => onGlobalFilterChange(e.target.value)}
              className="search-input"
            />
          </div>
          <div className="results-count">
            <span>{resultsCount} results</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScreenerSearchControls;
